<template>
  <v-app-bar
    app
    :color="isDemo && demoVariant !== null ? demoColor : 'white'"
    v-if="mdAndDown"
  >
    <v-btn @click="() => $router.push('/dashboard')" icon="mdi-home-outline"></v-btn>
    <v-spacer></v-spacer>
    <v-btn 
      @click="() => hasReviewEntities && $router.push('/analytics')" 
      icon="mdi-chart-line"
      :disabled="!hasReviewEntities"
      :style="{ opacity: hasReviewEntities ? 1 : 0.4 }"
    ></v-btn>
    <v-menu offset-y>
      <template v-slot:activator="{ props }">
        <v-btn icon v-bind="props">
          <v-icon>mdi-dots-vertical</v-icon>
        </v-btn>
      </template>
      
      <v-list>
        <v-list-item @click="feedbackOpen = true">
          <v-list-item-title>Feedback</v-list-item-title>
        </v-list-item>
        <v-list-item @click="() => $router.push('/profile')">
          <v-list-item-title>Profile</v-list-item-title>
        </v-list-item>
        <v-list-item @click="() => $router.push('/settings')">
          <v-list-item-title>Settings</v-list-item-title>
        </v-list-item>
        <v-list-item @click="logoutUser">
          <v-list-item-title>Logout</v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>    
  </v-app-bar>

  <v-navigation-drawer app rail expand-on-hover v-if="!mdAndDown" color="white">
    <v-list v-model:opened="open">
      <v-list-item prepend-icon="mdi-home-outline" title="Dashboard" @click="() => $router.push('/dashboard')"></v-list-item>
      <v-list-item 
        prepend-icon="mdi-chart-line" 
        title="AEO Analytics" 
        @click="() => hasReviewEntities && $router.push('/analytics')"
        :disabled="!hasReviewEntities"
        :style="{ opacity: hasReviewEntities ? 1 : 0.4 }"
      ></v-list-item>
      <v-list-item
        v-if="isAdmin"
        prepend-icon="mdi-lightbulb-on-outline"
        title="Prompts"
        @click="() => $router.push('/prompts')"
      ></v-list-item>
    </v-list>

    <template v-slot:append>
      <v-list-item prepend-icon="mdi-message-text-outline" title="Feedback" @click="feedbackOpen = true"></v-list-item>
      <v-list-item prepend-icon="mdi-account" title="Profile" @click="() => $router.push('/profile')"></v-list-item>
      <v-list-item prepend-icon="mdi-cog-outline" title="Settings" @click="() => $router.push('/settings')"></v-list-item>
      <v-list-item prepend-icon="mdi-exit-to-app" title="Logout" @click="logoutUser"></v-list-item>
    </template>
  </v-navigation-drawer>

  <FeedbackModal v-model="feedbackOpen" />
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { useDisplay } from 'vuetify';
import demoVariantList from "@/const.js";
import FeedbackModal from "@/components/FeedbackModal.vue";

export default {
  name: 'NavBar',
  components: { FeedbackModal },
  setup() {
    const { xs, mdAndDown } = useDisplay();
    return { xs, mdAndDown };
  },
  computed: {
    ...mapGetters(['hasReviewEntities', 'isAdmin']),
    isDevelopment() {
      return process.env.NODE_ENV === 'development';
    },
    variantImage() {
      return demoVariantList[this.demoVariant]?.imageUrl;
    },
    demoColor() {
      return demoVariantList[this.demoVariant]?.color;
    },
    isDemo() {
      return process.env.NODE_ENV === 'demo';
    }
  },
  methods: {
    ...mapActions(["logoutUser"])
  },
  data() {
    return {
      drawer: false,
      open: [],
      demoVariant: null,
      feedbackOpen: false
    };
  },
  mounted() {
    if (this.isDemo) {
      this.demoVariant = localStorage.getItem('demo_variant');
    }
  }
};
</script>

<style>
.navbar {
  background-color: #1abc9c;
}
</style>
